/** @jsxImportSource @emotion/react */
import { createStyles, Snackbar } from '@quickbit/qb-design-system';
import { ReactNode, FunctionComponent } from 'react';
import { useIntl } from 'react-intl';

interface Props {
  children: ReactNode;
}

const READONLY = process.env.REACT_APP_READONLY === 'true';

export const Layout: FunctionComponent<Props> = ({ children }) => {
  const styles = useStyles();
  const { formatMessage } = useIntl();

  return (
    <div css={styles.container}>
      {READONLY && (
        <Snackbar
          showAsBanner
          variant="primary"
          message={formatMessage({ id: 'readonly.pay.banner' })}
        />
      )}
      <main css={styles.content}>{children}</main>
    </div>
  );
};

const useStyles = createStyles(({ spacing, breakpoints, palette, sizing }) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    padding: `${spacing.xxs} ${spacing.xxs} ${spacing.m} ${spacing.xxs}`,
    background: palette.white,
    [breakpoints.laptopSmall]: {
      alignItems: 'center',
      paddingBottom: '0px',
    },
  },
  content: {
    flex: '1 1 auto',
    position: 'relative',
    [breakpoints.laptopSmall]: {
      maxWidth: sizing.large,
      width: '100%',
      paddingBottom: `calc(2 * ${spacing.m})`,
    },
  },
  footer: {
    width: '100%',
    maxWidth: sizing.medium,
    margin: 'auto',
    [breakpoints.laptopSmall]: {
      flex: 1,
      paddingLeft: spacing.m,
      paddingRight: spacing.m,
    },
  },
}));
